import React from 'react';

const StepIndicator = ({ currentStep = 0, numStep = 0, steps = [] }) => {
  return (
    <>
      <div id="indicators" className="max-w-indicators mx-auto">
        <div className="flex justify-between gap-1 mx-auto max-w-72 w-full">
          {Array.from({ length: numStep }, (_, index) => index + 1).map((step) => (
            <React.Fragment key={`step-${step}`}>
              {step < numStep && (
                <div className="relative">
                  <div
                    role="step"
                    className={`h-2.5 w-2.5 rounded-full border-2 ${currentStep >= step ? 'bg-primary-423 border-primary-423' : 'bg-black border-black opacity-25'} transition-colors`}
                  />
                </div>
              )}
              {step < numStep && <div className={`h-0.5 w-full mt-1 ${currentStep > step ? 'bg-primary-423' : 'bg-white-720'}`} />}
              {step === numStep ? (
                <div className="relative">
                  <div
                    role="step"
                    className={`h-2.5 w-2.5 rounded-full border-2 ${currentStep >= step ? 'bg-primary-423 border-primary-423' : 'bg-black border-black opacity-25'} transition-colors`}
                  />
                </div>
              ) : (
                <></>
              )}
            </React.Fragment>
          ))}
        </div>
        <div className="flex justify-between gap-1 mx-auto w-full mt-2">
          {Array.from({ length: numStep }, (_, index) => index + 1).map((step) => (
            <div
              key={`step-label-${step}`}
              className={`${currentStep >= step ? 'text-black' : 'text-black opacity-45'} ${currentStep === step && 'font-bold'} text-sm`}
            >
              {steps[step - 1].label}
            </div>
          ))}
        </div>
      </div>
      <div className="mt-8">{steps[currentStep - 1].element}</div>
    </>
  );
};

export default React.memo(StepIndicator);
